import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import LetterX from "../../autorizaciones/UI/LetterX";
import {
  getPracticasPorAgenda,
  deletePracticasPorAgenda,
} from "../../../actions/turnos/agenda";

const useStyles = makeStyles({
  letterX: {
    position: "relative",
    top: "0.12rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f706063b",
      borderRadius: "2rem",
    },
  },
});

const ConsultaPracticas = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { practicas } = useSelector((state) => state.agenda);

  const getDatePlusDays = (date, days) => {
    var result = date;
    result.setDate(date.getDate() + days);
    return result;
  };

  useEffect(() => {
    dispatch(getPracticasPorAgenda(props.idAgenda));
  }, [dispatch]);

  const deletePractica = (idCodNom) => {
    const practicaData = {
      idAgenda: props.idAgenda,
      idCodNom,
    };

    dispatch(deletePracticasPorAgenda(practicaData));
  };

  return (
    <Dialog
      fullWidth
      maxWidth={true ? "lg" : "sm"}
      open={props.open}
      onClose={props.onClose}
    >
      <DialogContent style={{ margin: "1rem 0" }}>
        {Array.isArray(practicas) && practicas.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "1%" }}></TableCell>
                <TableCell>Practica</TableCell>
                <TableCell align="right">Cantidad</TableCell>
                <TableCell align="right">Agregada</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {practicas.map((practica) => {
                return (
                  <TableRow key={practica?.nomencladorNacional?.id?.toString()}>
                    <TableCell>
                      {(
                        (practica?.agregada && getDatePlusDays(new Date(props?.fecha), 45) >= new Date()) ||
                        (!practica?.agregada && practica.valorCoseguro === 0)
                        ) &&
                       (
                        <LetterX
                          className={classes.letterX}
                          deleteFunction={() =>
                            deletePractica(practica?.idCodNom)
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell>{`${practica?.nomencladorNacional?.codNom} - ${practica?.nomencladorNacional?.desNom}`}</TableCell>
                    <TableCell align="right">{practica?.cant}</TableCell>
                    <TableCell align="right">
                      {practica?.agregada ? "SI" : "NO"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography style={{ fontSize: "1.1rem", fontStyle: "italic" }}>
            No hay practicas
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ConsultaPracticas;
